import React, { useEffect, useRef } from 'react';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import gsap from 'gsap/all';

import BasePageProps from '../../view2D/BasePageProps';
import BaseSection from '../../view2D/BaseSection';
import Image from '../../Image/Image';

import { useNavigationContext } from '../../../context/NavigationContext';
import { SectionIDs } from '../../../data/Sections';

import styles from './styles.module.scss';
import Div100vh from 'react-div-100vh';

function About({ ...props }: BasePageProps): JSX.Element {
  const { activeSectionID } = useNavigationContext();
  const { t } = useTranslation('ai4Jokes');

  const titleTextRef1 = useRef<HTMLDivElement>(null);
  const titleTextRef2 = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (activeSectionID === SectionIDs.About) {
      gsap.fromTo(titleTextRef1.current, { bottom: '-2rem' }, { bottom: '2.5rem', duration: 0.3, delay: 0.1 });
      gsap.fromTo(titleTextRef2.current, { bottom: '-4rem' }, { bottom: '0rem', duration: 0.3, delay: 0.1 });
      gsap.fromTo(textRef.current, { opacity: '0', top: '1rem' }, { opacity: '1', top: '0rem', duration: 0.3, delay: 0.1 });
    }
  },
  [activeSectionID]);

  return (
    <BaseSection className={styles.base} {...props} >
      <Div100vh className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.picture}>
            <Image
              alt='Dr. Tiansi Dong picture'
              filename='drdong'
              imageConfig={{
                '(min-width: 900px)': {
                  sizes: {
                    '1x': 'lg-1x',
                    '2x': 'lg-2x',
                  },
                  type: 'jpg'
                },
                '(min-width: 600px)': {
                  sizes: {
                    '1x': 'md-1x',
                    '2x': 'md-2x',
                  },
                  type: 'jpg'
                },
                '(max-width: 599px)': {
                  sizes: {
                    '1x': 'sm-1x',
                    '2x': 'sm-2x',
                  },
                  type: 'jpg'
                }
              }} />
          </div>
          <div className={styles.content}>
            <h2 className={styles.title} ref={titleTextRef1}>{t('about.name')}</h2>
            <p className={styles.jobTitle} ref={titleTextRef2}>{t('about.title')}</p>
            <p className={styles.aboutDetail} ref={textRef}>{parse(t('about.paragraph'))}</p>
            <div className={styles.interests}>
              <p>{t('about.interests.title')}</p>
              <ul className={styles.interestList}>
                <li>{t('about.interests.1')}</li>
                <li>{t('about.interests.2')}</li>
                <li>{t('about.interests.3')}</li>
              </ul>
            </div>
            <div className={styles.links}>
              <a
                href='mailto:ml2r-pr@iais.fraunhofer.de'
                target='_blank'
                rel='noreferrer'>
                {t('about.contact')}
              </a>
              <a
                href='https://tiansidr.github.io/publications.html'
                target='_blank'
                rel='noreferrer'>
                {t('about.publications')}
              </a>
              <a
                href='https://www.linkedin.com/in/tiansi-dong-74559313a/'
                target='_blank'
                rel='noreferrer'>
              Linkedin
              </a>
            </div>
          </div>
        </div>
      </Div100vh>
    </BaseSection>

  );
}


export default React.memo(About);